/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does flow rate scale?`)
};

const es_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo escala el caudal?`)
};

const de_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie skaliert die Flussrate?`)
};

const nl_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe schaalt de flowsnelheid?`)
};

const fr_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le débit s'adapte-t-il ?`)
};

const it_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come scala la portata?`)
};

const pt_br2_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a vazão é dimensionada?`)
};

const pt_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como escala o caudal?`)
};

const ja_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流速はどのようにスケーリングされますか?`)
};

const zh_hplc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流速是如何按比例变化的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_q2", locale)
	if (locale === "en") return en_hplc_faq_q2(inputs)
	if (locale === "es") return es_hplc_faq_q2(inputs)
	if (locale === "de") return de_hplc_faq_q2(inputs)
	if (locale === "nl") return nl_hplc_faq_q2(inputs)
	if (locale === "fr") return fr_hplc_faq_q2(inputs)
	if (locale === "it") return it_hplc_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_q2(inputs)
	if (locale === "pt") return pt_hplc_faq_q2(inputs)
	if (locale === "ja") return ja_hplc_faq_q2(inputs)
	return zh_hplc_faq_q2(inputs)
};